import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ChangeTypeDto, ChangeTypeRequestDto } from 'src/api/FiretrolApiClient';
import { changeTypeApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateChangeType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: ChangeTypeRequestDto) =>
      changeTypeApiClient.create(request),
    meta: {
      successMessageFn: (data) => `"${(data as ChangeTypeDto).name}" Created`,
    },
    onSettled: () => invalidateFor('changeType.save', qc),
  });
}

export function useUpdateChangeType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      request,
    }: {
      id: string;
      request: ChangeTypeRequestDto;
    }) => changeTypeApiClient.update(id, request),
    meta: { successMessage: 'Change Type Updated!' },
    onSettled: () => invalidateFor('changeType.save', qc),
  });
}

export function useDeleteChangeType() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => changeTypeApiClient.delete(id),
    meta: {
      successMessage: 'Change Type Deleted!',
      errorContext: 'delete change type',
    },
    onSettled: () => invalidateFor('changeType.save', qc),
  });
}
